/**
 * @copyright WaterStreet. All rights reserved.
 */

/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
	Component,
	Input,
	OnInit
} from '@angular/core';
import {
	IDynamicComponentContext
} from '@shared/interfaces/application-objects/dynamic-component-context.interface';
import {
	IDynamicComponent
} from '@shared/interfaces/application-objects/dynamic-component.interface';
import {
	IKeyValuePair
} from '@shared/interfaces/application-objects/key-value-pair.interface';

/* eslint-enable max-len */

@Component({
	selector: 'app-key-value-pair',
	templateUrl: './key-value-pair.component.html',
	styleUrls: [
		'./key-value-pair.component.scss'
	]
})

/**
 * A generic reusable component for displaying key-value pairs in a single
 * column layout. Keys are displayed in bold followed by `: ` with a single
 * space, then the value. The entire text uses ellipsis truncation as a
 * unified string.
 *
 * @export
 * @class KeyValuePairComponent
 * @implements {OnInit}
 * @implements {IDynamicComponent<Component, any>}
 */
export class KeyValuePairComponent
implements OnInit, IDynamicComponent<Component, any>
{
	/**
	 * Gets or sets the key-value pairs to display directly via input binding.
	 * Takes priority over context.data.keyValuePairs.
	 *
	 * @type {IKeyValuePair[]}
	 * @memberof KeyValuePairComponent
	 */
	@Input() public keyValuePairs: IKeyValuePair[];

	/**
	 * Gets or sets the context of this dynamic component that will be set
	 * during initialization. The source is the content component and
	 * the data will be associated data that we desire to pass explicitly.
	 * Expected to contain data.keyValuePairs as a pre-parsed array.
	 *
	 * @type {IDynamicComponentContext<Component, any>}
	 * @memberof KeyValuePairComponent
	 */
	@Input() public context:
		IDynamicComponentContext<Component, any>;

	/**
	 * Gets or sets the key-value pairs to display.
	 *
	 * @type {IKeyValuePair[]}
	 * @memberof KeyValuePairComponent
	 */
	public pairs: IKeyValuePair[] = [];

	/**
	 * Handles the on initialization event.
	 * Assigns pre-parsed key-value pairs from input or context.
	 * Priority: keyValuePairs input > context.data.keyValuePairs > empty array.
	 *
	 * @memberof KeyValuePairComponent
	 */
	public ngOnInit(): void
	{
		// Priority 1: Direct @Input keyValuePairs
		if (this.keyValuePairs?.length > 0)
		{
			this.pairs = this.keyValuePairs;
		}
		// Priority 2: Context data keyValuePairs (already parsed)
		else if (this.context?.data?.keyValuePairs)
		{
			this.pairs = this.context.data.keyValuePairs;
		}
		// Priority 3: Empty fallback
		else
		{
			this.pairs = [];
		}
	}
}